import { MonthType } from './month-type';
import { Anniversary } from './anniversary';

/**
 * 현재 달력에서의 날짜에 대한 정보를 가지는 클래스
 * view에 출력하기 위한 자료 구조
 */
export class Day {

  /**
   * 날짜
   */
  private $date: Date;

  /**
   * 날짜의 달의 유형
   */
  private $type: MonthType;

  /**
   * 날짜가 오늘인지 여부
   */
  private $today: boolean;

  /**
   * 기념일 목록, 배열이 비어있거나 null 이면 기념일 없음을 의미
   */
  private $anniversaries: Anniversary[];

  /**
   * 기념일을 첫 번째 글자만 출력할지 여부
   */
  private $isDisplayShortAnniversary: boolean;

  /**
   * @constructor
   * @param {number} date 날짜
   * @param {MonthType} type 현재 달력에서 이 날짜의 달의 유형
   * @param {Anniversary|Array<Anniversary>?} anniversary 기념일 정보
   */
  constructor(
    date: Date,
    type: MonthType,
    anniversary: any = null) {
    this.$date = date;
    this.$type = type;
    this.$today = false;
    this.$isDisplayShortAnniversary = false;

    // 기념일이 배열이라면 그대로 저장, 인스턴스라면 배열을 생성하여 저장
    if (anniversary && anniversary.constructor === Array) {
      this.$anniversaries = anniversary;
    } else {
      this.$anniversaries = [];
      if (anniversary) {
        this.$anniversaries.push(anniversary);
      }
    }
  }

  /**
   * 날짜 객체 반환
   */
  public get date(): Date {
    return this.$date;
  }

  /**
   * 날짜의 '일' 반환
   */
  public get day(): number {
    return this.$date.getDate();
  }

  /**
   * 현재 달력에서 이 날짜가 이전 달인지 여부 반환
   */
  public get isPast(): boolean {
    return this.$type === MonthType.PREV_MONTH;
  }

  /**
   * 현재 달력에 이 날짜가 다음 달인지 여부 반환
   */
  public get isFuture(): boolean {
    return this.$type === MonthType.NEXT_MONTH;
  }

  /**
   * 현재 달력에서 이 날짜가 이번 달인지 여부 반환
   */
  public get isThisMonth(): boolean {
    return this.$type === MonthType.THIS_MONTH;
  }

  /**
   * 현재 달력에서 이 날짜가 오늘인지 여부 반환
   */
  public get isToday(): boolean {
    return this.$today;
  }

  /**
   * 이 날짜가 기념일인지 여부 반환
   */
  public get isAnniversary(): boolean {
    return this.$anniversaries.length > 0;
  }

  /**
   * 기념일 목록 반환, 현재 옵션에 따라 첫 번째 글자만 출력하거나 모두 출력함
   */
  public get anniversaries(): Anniversary[] {
    let arr: Anniversary[] = null;
    if (this.$isDisplayShortAnniversary) {
      arr = [];
      for (let i = 0, d: Anniversary; d = this.$anniversaries[i]; i += 1) {
        d.name = d.name.substring(0, 1);
      }
    }
    arr = this.$anniversaries;
    return arr;
  }

  /**
   * 날짜의 기념일 타입 이름 목록
   */
  public get anniversaryTypes(): string[] {
    const types: string[] = [];

    // 중복된 타입 이름은 제외
    for (let i = 0, max = this.$anniversaries.length; i < max; i += 1) {
      const type = this.$anniversaries[i].type;
      if (types.indexOf(type) === -1) {
        types.push(type);
      }
    }

    return types;
  }

  /**
   * 현재 달력에서 이 날짜가 오늘인지 여부 설정
   * @param {boolean} b 오늘인지 여부
   */
  public set isToday(b: boolean) {
    this.$today = b;
  }

  /**
   * 기념일 첫 글자만 출력 여부 설정
   * @param {boolean} b 첫 글자만 출력 여부
   */
  public set isDisplayShortAnniversary(b: boolean) {
    this.$isDisplayShortAnniversary = b;
  }
}
